import { Component, Vue } from "vue-property-decorator";
import DashboardCardList from "@/modules/Dashboards/components/DashboardCardList/DashboardCardList.vue";
import {
  DASHBOARD_CONST,
  DASHBOARD_PRINCIPAL
} from "../constants/DashboardConstants";
import { DashboardCard } from "../models/DashboardCard";
import { LOCAL_STORAGE } from "@/shared/constants/FormConstants";
import { LOGIN_CONSTANTS } from "@/modules/Login/constants/LoginConstants";
import firebase from "firebase";
import store from "@/store";

@Component({
  name: "PrincipalDashboard",
  components: { DashboardCardList }
})
export default class PrincipalDashboard extends Vue {
  TITLE = "";

  listCard: DashboardCard[] = [];

  mounted() {
    this.redirectLogin();
    this.listCard = DASHBOARD_PRINCIPAL;
    this.TITLE =
      DASHBOARD_CONST.HOME.TITLE +
      localStorage.getItem(LOCAL_STORAGE.USER_NAME);
  }

  redirectLogin() {
    const roles = localStorage.getItem(LOCAL_STORAGE.ROLE)?.split(",");
    if (roles!.length === 1 && roles![0] === LOGIN_CONSTANTS.ROLE_PATIENT) {
      localStorage.clear();
      firebase.auth().signOut();
      store.commit("changeSession", false);
      store.commit("setRole", "");
      store.commit("setUserName", "");
      store.commit("setAvatar", "");
      this.$router.push("/login");
    }
  }
}
